import './Header.scss';

import Contacts from 'components/partials/contacts/Contacts';
import PrimaryHeaderNav from 'components/partials/navs/components/primary-header-nav/PrimaryHeaderNav';
import _get from 'lodash/get';
import PropTypes from 'prop-types';
import React, { Suspense, lazy } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import { connect } from 'react-redux';

import Logo from './components/logo/Logo';
import SiteSearch from './components/site-search/SiteSearch';

const MyAccountHeaderNav = lazy(() =>
  import(
    'components/partials/navs/components/my-account-header-nav/MyAccountHeaderNav'
  )
);

const AuthModalButton = lazy(() =>
  import(
    'components/partials/auth-modal/components/auth-modal-button/AuthModalButton'
  )
);

const propTypes = {
  isMobile: PropTypes.bool,
  userIsLoggedIn: PropTypes.bool
};

const Header = ({ userIsLoggedIn, isMobile }) => {
  return (
    <header id="no-print" className="primary-header" role="banner">
      <div className="top-line">
        <Container>
          <Logo isMobile={isMobile} />
          <Row className="align-items-center justify-content-end">
            <Contacts />
            <SiteSearch />
            <Suspense fallback={null}>
              {userIsLoggedIn && <MyAccountHeaderNav />}
              {!userIsLoggedIn && <AuthModalButton />}
            </Suspense>
          </Row>
        </Container>
      </div>

      <PrimaryHeaderNav />
    </header>
  );
};

Header.propTypes = propTypes;

const mapStateToProps = state => ({
  isMobile: _get(state, 'main.isMobile'),
  userIsLoggedIn: _get(state, 'user.isLoggedIn')
});

export default connect(mapStateToProps)(Header);
